/*eslint indent: ["error", 2, { "SwitchCase": 1 }]*/
import BootstrapTable from 'react-bootstrap-table-next'
import ItemIconRow from '../ItemIconRow'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import RowsContext from '../RowsContext'
import paginationFactory from 'react-bootstrap-table2-paginator'
import produce from 'immer'
import queryString from 'query-string'
import { Dropdown, DropdownButton } from 'react-bootstrap'
import { Link, withRouter } from 'react-router-dom'
import { dateFormatter } from '../../utils/dateFunctions'
// import ItemRowActionsMenu from '../ItemRowActionsMenu'
// import FolderRowActionsMenu from '../FolderRowActionsMenu'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink, faFolder } from '@fortawesome/free-solid-svg-icons'
import routes from '../../routes'

class ChildListTable extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      files: [],
      selectedRows: [],
      clearSelectedRows: () => {
        this.setState(produce(draft => {
          draft.selectedRows = []
        }))
      }
    }

    // function binds
    this.handleOnSelect = this.handleOnSelect.bind(this)
    this.handleOnSelectAll = this.handleOnSelectAll.bind(this)
    this.onTableChange = this.onTableChange.bind(this)

    this.histUnlisten = this.props.history.listen(() => {
      this.setState(produce((draft) => {
        draft.selectedRows = []
      }))
    })
  }

  handleOnSelect(row, isSelect) {
    if (isSelect && row.__typename === 'MetadataItem') {
      this.setState(produce((draft) => {
        draft.selectedRows.push(row)
      }))
    } else {
      this.setState(produce((draft) => {
        draft.selectedRows = draft.selectedRows.filter(x => x.id !== row.id)
      }))
    }
  }

  handleOnSelectAll(isSelect, rows) {
    const files = rows.filter(r => r.__typename ==='MetadataItem')
    if (isSelect && files) {
      this.setState(produce((draft) => {
        draft.selectedRows = files
      }))
    } else {
      this.setState(produce((draft) => {
        draft.selectedRows = []
      }))
    }
  }

  componentWillUnmount() {
    this.histUnlisten()
  }

  onTableChange(type, newState) {
    const search = queryString.parse(this.props.location.search)

    const sortField = newState.sortField === 'provenance.lastUpdated' ? 'lastUpdated' :
      newState.sortField === 'provenance.dateCreated' ? 'dateCreated' : newState.sortField
    switch (type) {
      case 'pagination':
        this.props.history.push({
          pathname: this.props.location.pathname,
          search: queryString.stringify(Object.assign({}, search, {
            page: newState.page,
            max: newState.sizePerPage,
          })),
        })

        break
      case 'sort':
        this.props.history.push({
          pathname: this.props.location.pathname,
          search: queryString.stringify(Object.assign({}, search, {
            sort: sortField,
            order: newState.sortOrder,
          })),
        })
        break
      default:
        console.error(`Case: ${type} not handled for table`)
    }
  }

  render() {
    const columns = [
      {
        dataField: 'title',
        text: 'Title',
        sort: true,
        classes: 'td-name',
        formatter: (cell, row) => {
          if (row.linkParentIds !== null && !row.linkParentIds.includes(this.props.id)) {
            return (
              <div className="text-collapse">
                <div className="table-icon-left">
                  <i><FontAwesomeIcon icon={faLink} fixedWidth /></i>
                </div>
                <div className="table-row-title">
                  <Link to={`${routes.itemPath}/${row.id}`} title={cell}>
                    {cell}
                  </Link>
                  <div className="table-icon-right">
                    <ItemIconRow item={row} />
                  </div>
                </div>
              </div>
            )
          }
          else {
            let linkTo = `${routes.itemPath}/${row.id}`

            return (
              <div className="text-collapse">
                <div className="table-icon-left">
                  <FontAwesomeIcon icon={faFolder} fixedWidth />
                </div>
                <div className="table-row-title">
                  <Link to={linkTo} title={cell}>
                    {cell}
                  </Link>
                  <div className="table-icon-right">
                    <ItemIconRow item={row} />
                  </div>
                </div>
              </div>
            )
          }

        }
      },
      {
        dataField: 'provenance.lastUpdated',
        text: 'Last Updated',
        sort: true,
        formatter: (cell) => {
          return (
            <div className="text-collapse">
              {dateFormatter(cell)}
            </div>
          )
        }
      },
      {
        dataField: 'provenance.dateCreated',
        text: 'Date Created',
        sort: true,
        formatter: (cell) => {
          return (
            <div className="text-collapse">
              {dateFormatter(cell)}
            </div>
          )
        }
      },
      // {
      //   dataField: 'facets',
      //   text: 'Extension Types',
      //   sort: false,
      //   formatter: (cell) => {
      //     let facetNames
      //     if (Array.isArray(cell)) {
      //       facetNames = cell.map((facet, idx) => {
      //         return (
      //           <li key={`${facet.facetName}-${idx}`}>{facet.facetName}</li>
      //         )
      //       })
      //     }
      //
      //     return (
      //       <div className="text-collapse">
      //         <ul>
      //           {facetNames}
      //         </ul>
      //       </div>
      //     )
      //   }
      // },
      // {
      //   dataField: 'button',
      //   text: 'Actions Menu',
      //   formatter: (_, row) => {
      //     if (!row.hasChildren) {
      //       return (
      //         <ItemRowActionsMenu row={row} canWrite={ row.permissions.currentUser.canWrite } />
      //       )
      //     } else {
      //       return (
      //         <div className="btn-group">
      //           <FolderRowActionsMenu row={row} canWrite={ row.permissions.currentUser.canWrite } />
      //         </div>
      //       )
      //     }
      //     // return (<p>Actions</p>)
      //   }
      // }
    ]

    // const selectRow = {
    //   mode: 'checkbox',
    //   selected: this.state.selectedRows.map(row => row.id),
    //   onSelect: this.handleOnSelect,
    //   onSelectAll: this.handleOnSelectAll,
    // }

    const paginationTotalRenderer = (from, to, size) => (
      <span className="react-bootstrap-table-pagination-total">
        Showing {from} to {to} of {size} results
      </span>
    )

    const sizePerPageRenderer = ({ onSizePerPageChange }) => (
      <DropdownButton id="dropdown-page-size-button"
        title={this.props.queryVariables.max}
        onSelect={onSizePerPageChange}
        variant="secondary"
      >
        <Dropdown.Item eventKey="10">10</Dropdown.Item>
        <Dropdown.Item eventKey="25">25</Dropdown.Item>
        <Dropdown.Item eventKey="50">50</Dropdown.Item>
        <Dropdown.Item eventKey="100">100</Dropdown.Item>
      </DropdownButton>
    )

    const paginationOptions = {
      page: parseInt(queryString.parse(this.props.location.search).page) || 1,
      paginationTotalRenderer,
      showTotal: true,
      sizePerPage: parseInt(this.props.queryVariables.max),
      sizePerPageRenderer,
      totalSize: this.props.childItems.totalCount,
    }

    return (
      <RowsContext.Provider value={this.state}>
        <div className="sb-table-listing">
          <BootstrapTable
            responsive
            wrapperClasses="table-responsive"
            keyField='id'
            data={this.props.childItems.items || []}
            columns={columns}
            noDataIndication="No child items available"
            bordered={false}
            // selectRow={selectRow}
            hover
            pagination={paginationFactory(paginationOptions)}
            remote={{
              filter: true,
              pagination: true,
              sort: true,
              cellEdit: false,
            }}
            onTableChange={this.onTableChange}
          ></BootstrapTable>
        </div>
      </RowsContext.Provider>
    )
  }
}

ChildListTable.propTypes = {
  id: PropTypes.string,
  childItems: PropTypes.shape({
    items: PropTypes.array,
    totalCount: PropTypes.number,
  }),
  // The react specific route context
  parentId: PropTypes.string,
  // An optional prefix to prepend to the path when sending to the server
  queryVariables: PropTypes.shape({
    parentId: PropTypes.string,
    path: PropTypes.string,
    max: PropTypes.number,
    offset: PropTypes.number,
    sort: PropTypes.string,
    order: PropTypes.string,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
  history: PropTypes.shape({
    listen: PropTypes.func,
    push: PropTypes.func,
  })
}

export default withRouter(ChildListTable)
